/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Low_Signal_StrengthInputs */



/**
* | output |
* | --- |
* | "Low signal strength" |
*
* @param {Low_Signal_StrengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const low_signal_strength = /** @type {((inputs?: Low_Signal_StrengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Signal_StrengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Low signal strength")
	return /** @type {LocalizedString} */ ("Puissance du signal faible")
});